import HttpRoutingService from "../../shared/services/httpRoutingService";
import { API } from "../../shared/apiRoutes";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { CustomerHistoryDetails, CustomerHistoryResponse } from "../../components/sellScreen/viewCustomerDetails.model";

export interface StoreHistoryRow {
    id: number;
    date: string;
    Staff: string;
    email: string;
    status: string;
    notes: string;
    amount: string;
}

export interface AccountHistoryRow {
    id: number;
    date: string;
    order: string;
    status: string;
    payment: string;
    amount: string;
    balance: string;
}


interface InitialState {
    getCustomerHistory: {
        loading: boolean;
        values: CustomerHistoryDetails | null;
        error: string;
        /** Cached customer ID — used to skip redundant fetches */
        cachedCustomerId: number | null;
    };
}

const initialState: InitialState = {
    getCustomerHistory: {
        loading: false,
        values: null,
        error: '',
        cachedCustomerId: null,
    },
};

export const getCustomerHistory = createAsyncThunk(
    'viewCustomerDetails/getCustomerHistory',
    ({ storeId, customerId }: { storeId: number; customerId: number; }) => {
        const url = HttpRoutingService.replaceUrl(API.getCustomerHistory, { storeId, customerId });
        return HttpRoutingService.getMethod<CustomerHistoryResponse>(url);
    }
);

export const viewCustomerDetailsSlice = createSlice({
    name: 'viewCustomerDetails',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(getCustomerHistory?.pending, (state) => {
                state.getCustomerHistory.loading = true;
            })
            .addCase(getCustomerHistory?.fulfilled, (state, action) => {
                state.getCustomerHistory.loading = false;
                state.getCustomerHistory.values = action.payload?.customerDetails;
                // Cache the customer ID so the component can skip redundant fetches
                state.getCustomerHistory.cachedCustomerId = action.meta.arg.customerId;
            })
            .addCase(getCustomerHistory?.rejected, (state, action) => {
                state.getCustomerHistory.loading = false;
                state.getCustomerHistory.error = action?.error?.message as string || "Failed to get the customer details";
            })


    },
})

export default viewCustomerDetailsSlice.reducer
